import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import axios from "axios";

import "./entries.css";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
// import ReceptionForm from "./reception-form";
import FormsView from "./FormsView";

function Entries() {
  const [masterValue, setMasterValue] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("input");
  const [error, setError] = useState("");

  const handleMaster = async () => {
    const userData = localStorage.getItem("user");
    const user = userData ? JSON.parse(userData) : null;

    const regex = /^\d{3}-\d{8}$/;
    if (!masterValue.trim()) {
      setError("Este campo es obligatorio");
      return;
    }
    if (!regex.test(masterValue)) {
      setError("Formato de master invalido");
      return;
    }

    setError("");
    setLoading(true);

    const params = {
      master: masterValue,
      user_id: user?.id || 1,
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/getMaster`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (res.data?.code === 1) {
        setData(res.data.data || {});
        setTimeout(() => {
          setView("forms");
          setLoading(false);
        }, 1000);
      } else if (res.data?.code === -1) {
        setLoading(false);
        Swal.fire({
          title: "La master no existe favor de verificar",
          icon: "warning",
          iconColor: "#FCC732",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      console.error("Error fetching master:", error);
      setLoading(false);
      Swal.fire({
        title: "Hubo un error inesperado",
        icon: "error",
        iconColor: "#f90034",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
  };

  const handleMasterChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    if (value.length > 11) return;
    if (value.length > 3) {
      value = value.slice(0, 3) + "-" + value.slice(3);
    }

    setMasterValue(value);
    setError("");
  };

  return (
    <>
      <Helmet>
        <title>Horus | Entrada</title>
      </Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                value={masterValue}
                onChange={handleMasterChange}
                maxLength={12}
                onKeyDown={(e) => e.key === "Enter" && handleMaster()}
              />
              {error && <small className="text-danger">{error}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleMaster}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {view === "forms" && data && (
          <FormsView master={data} loading={loading} setLoading={setLoading} />
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Entries;
